import findEscapeRoute from './findEscapeRoute.js';
import getAgentFreshUnitsNotInDanger from './getAgentFreshUnitsNotInDanger.js';
import getCommandToBlockPathToAgentUnit from './getCommandToBlockPathToAgentUnit.js';
import getVacantNeighbours from './getVacantNeighbours.js';
function findCommandForAgentUnit(agentUnit, rankedPositions, rankedPositionsById, hexProperties, gameState, rules, mapHexes, agentUnits, agentUnitsInDanger) {
    // if it is fresh
    if (!agentUnit.isFatigued) {
        // and can escape, then escape
        const orderSpec = findEscapeRoute({
            agentUnit,
            rankedPositions,
            hexProperties,
            gameState,
            rules,
            mapHexes,
            agentUnits,
            agentUnitsInDanger,
        });
        if (orderSpec) {
            return orderSpec;
        }
    }
    else {
        // otherwise can other non-candidate units block path to the unit?
        //     block
        const agentFreshUnitsNotInDanger = getAgentFreshUnitsNotInDanger(agentUnit, agentUnits, agentUnitsInDanger, hexProperties);
        const vacantNeighbours = getVacantNeighbours(agentUnit, rules, gameState.units, rankedPositionsById);
        for (const neighbour of vacantNeighbours) {
            const command = getCommandToBlockPathToAgentUnit(agentUnit, agentFreshUnitsNotInDanger, neighbour, rankedPositionsById, hexProperties, rules, gameState, mapHexes);
            if (command) {
                return command;
            }
        }
    }
    return null;
}
export default findCommandForAgentUnit;
